module.exports = __webpack_public_path__ + "img/4.f833d273.jpg";